import * as React from "react";
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Typography,
} from "@mui/material";
import {useTranslation} from "react-i18next";

interface LockPeriodConfirmDialogProps {
    open: boolean;
    currentAction: "lock" | "unlock" | null;
    lockButtonText: string;
    lockButtonColor: string | undefined;
    isOpenState: boolean;
    onCancel: () => void;
    onConfirm: () => void;
}

export default function LockPeriodConfirmDialog({
    open,
    currentAction,
    lockButtonText,
    lockButtonColor,
    isOpenState,
    onCancel,
    onConfirm,
}: LockPeriodConfirmDialogProps): React.ReactElement {
    const {t} = useTranslation();
    return (
        <Dialog
            open={open}
            onClose={() => {
            }}
            disableEscapeKeyDown
            aria-labelledby="confirmation-dialog-title"
            aria-describedby="confirmation-dialog-description"
        >
            <DialogTitle id="confirmation-dialog-title">
                {currentAction === "lock" ? t('payroll.period.dialog.lockTitle') : t('payroll.period.dialog.unlockTitle')}
            </DialogTitle>
            <DialogContent>
                <Typography variant="body1" gutterBottom>
                    {currentAction === "lock"
                        ? t('payroll.period.confirm.lock')
                        : t('payroll.period.confirm.unlock')}
                </Typography>
            </DialogContent>
            <DialogActions>
                <Button onClick={onCancel} color="primary">
                    {t('common.actions.cancel')}
                </Button>
                <Button
                    onClick={onConfirm}
                    sx={{
                        backgroundColor: lockButtonColor,
                        "&:hover": {
                            backgroundColor: isOpenState ? "#f57c00" : undefined,
                        },
                    }}
                    variant="contained"
                >
                    {lockButtonText}
                </Button>
            </DialogActions>
        </Dialog>
    );
}
